import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

export const isClientAccepted = (intro, clientDetails) => {
  const clientShortName = clientDetails.shortName;

  if (!clientShortName) {
    return _isEmpty(_get(intro, 'fields.client', []));
  }

  const introClients = _get(intro, 'fields.client', []);
  const matchesClient = introClients.some(
    client => _get(client, 'fields.shortName') === clientShortName,
  );
  if (introClients.length > 0 && !matchesClient) return false;

  const introExcludeClients = _get(intro, 'fields.excludeClient', []);
  const matchesExcludeClient = introExcludeClients.some(
    client => _get(client, 'fields.shortName') === clientShortName,
  );
  return !matchesExcludeClient;
};

export const tagsMatches = (introTags, tags) =>
  tags.some(({ id }) => introTags.some(tag => tag.sys.id === id));
